import { Stack, Typography } from "@mui/material";
import { StyledCardStack, StyledShipmentBox } from "./styles";
import { useFormContext } from "react-hook-form";
import { HubHookCustomersSelect } from "../HubHookCustomersSelect";
import { HubHookFormCustomerAddress } from "../HubHookFormCustomerAddress";

export const Label = ({ label, value, isRow }) => {
  const sx = isRow
    ? {
        direction: "row",
        gap: "3px",
        alignItems: "center",
      }
    : {};

  return (
    <Stack {...sx}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography variant="body2" fontWeight={500}>
        {value}
      </Typography>
    </Stack>
  );
};

const ShipmentInfo = () => {
  const { watch } = useFormContext();
  const purchaserId = watch("purchaserId");
  const receiverId = watch("receiverId");

  return (
    <Stack direction="row" justifyContent="space-between">
      <StyledCardStack>
        <Stack gap="2px">
          <Typography variant="caption" lineHeight="12px">
            Bill To:
          </Typography>
          <StyledShipmentBox>
            <HubHookCustomersSelect
              name="purchaserId"
              label={null}
              shouldUnregister={false}
              rendered={false}
              required
            />
            <HubHookFormCustomerAddress
              name="billToId"
              label={null}
              customerId={purchaserId}
              sx={{ minHeight: "46px" }}
              shouldUnregister={false}
              rendered
            />
          </StyledShipmentBox>
        </Stack>
      </StyledCardStack>
      <StyledCardStack>
        <Stack gap="2px">
          <Typography variant="caption" lineHeight="12px">
            Ship To:
          </Typography>
          <StyledShipmentBox>
            <HubHookCustomersSelect
              name="receiverId"
              label={null}
              shouldUnregister={false}
              rendered={false}
              required
            />
            <HubHookFormCustomerAddress
              name="shipToId"
              label={null}
              customerId={receiverId}
              shouldUnregister={false}
              sx={{ minHeight: "46px" }}
              rendered
            />
          </StyledShipmentBox>
        </Stack>
      </StyledCardStack>
    </Stack>
  );
};

export default ShipmentInfo;
